import { LoginResponse, wgLogType, wgModules } from "../models/index";
import { wglcsApiService } from "../services/WglcsApiService";

class logs {
    saveLog = async (crudType: wgLogType, moduleName: wgModules, refrenceKey: string, data: any, optionalMessage: string = "", arrayFormData: [] = []) => {
        let UserData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        var values: string = optionalMessage;

        for (let [key, value] of Object.entries(data)) {
            values = values + `${key}:${value},`;
        }

        arrayFormData?.map(element => {
            for (let [key, value] of Object.entries(element)) {
                values = values + `${key}:${value},`;
            }
        });

        const body = {
            id: 0,
            changeType: crudType.toString(),
            userId: UserData?.userLoginData?.userId,
            userName: UserData?.userLoginData?.username,
            changeTime: new Date(),
            interface: moduleName.toString(),
            refrenceKey: refrenceKey,
            wgLogChildViewModel: [
                {
                    id: 0,
                    change: values,
                    refrenceKey: refrenceKey
                }
            ]
        }

        await wglcsApiService.savewglog(body);
    }


    rolePermissionLogs = async (crudType: wgLogType, moduleName: wgModules, refrenceKey: string, values: any) => {
        let UserData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;

        const body = {
            id: 0,
            changeType: crudType.toString(),
            userId: UserData?.userLoginData?.userId,
            userName: UserData?.userLoginData?.username,
            changeTime: new Date(),
            interface: moduleName.toString(),
            refrenceKey: refrenceKey,
            wgLogChildViewModel: [
                {
                    id: 0,
                    change: values,
                    refrenceKey: refrenceKey
                }
            ]
        }

        await wglcsApiService.savewglog(body);
    }
}
var wgLogs = new logs();
export { wgLogs };